module.exports = __webpack_public_path__ + "img/artboard.3533c602.jpg";